var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<article class=\"combo tengo-club\">\r\n    <header>\r\n        <h4>\r\n            ¿Tenés Club LA NACION\r\n            Black o Premium?\r\n        </h4>\r\n        <hr>\r\n        <p>No hace falta que compres</p>\r\n    </header>\r\n    <p class=\"tengo-club__descrip\">\r\n        Ingresá los datos de tu tarjeta y continuá\r\n        <strong>Sin cargo</strong>\r\n    </p>\r\n    <button class=\"next-button\" type=\"button\" data-step=\"combo_procesar\" data-combo=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.Config : depth0)) != null ? stack1.COMBO_BONIFICADO : stack1), depth0))
    + "\" data-source=\"wall\">Tengo Club</button>\r\n    <div class=\"combo__img\"></div>\r\n</article>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./Statics/scripts/paywall/views/partials/combo/tengo_club.hbs
// module id = 488
// module chunks = 0 1